function createSlotMetadataStore() {
  const store = new WeakMap<
    googletag.Slot,
    Pick<
      googletag.events.SlotRenderEndedEvent,
      'creativeId' | 'lineItemId' | 'advertiserId' | 'campaignId'
    >
  >();

  return {
    setFromEvent: (event: googletag.events.SlotRenderEndedEvent) => {
      const { slot, lineItemId, creativeId, campaignId, advertiserId } = event;
      store.set(slot, { lineItemId, creativeId, campaignId, advertiserId });
    },
    get: (slot: googletag.Slot) => store.get(slot),
    clear: (slot: googletag.Slot) => store.delete(slot)
  } as const;
}

export const slotMetadataStore = createSlotMetadataStore();
